import {
  borderRadius,
  borders,
  colors,
  fonts,
  fontSizes,
  fontStyles,
  fontWeights,
  lineHeights,
  opacities,
  shadows,
  spacings,
} from '@getlove/tokens';

export default {
  borderRadius,
  borders,
  fonts,
  fontSizes,
  fontStyles,
  fontWeights,
  lineHeights,
  opacities,
  shadows,
  grid: {
    container: '130rem',
    gutter: '3.2rem',
  },
  border: {
    radius: {
      medium: '0.4rem',
      large: '0.8rem',
    },
  },
  colors: {
    ...colors,
    primaryLight: '#EB7573',
    primary: '#DD4F50',
    primaryDark: '',
    secondaryLight: '#4476C8',
    secondary: '#3861BA',
    secondaryDark: '',
    lowContrast: '#F7F5F5',
    contrast: '#908f8f',
    highContrast: '#676666',
    lightContrast: '#dedbd3',
    white: '#ffffff',
    black: '#141414',
    dark: '#20252A',
    error: '#EB7573',
    warning: '#e9bb63',
    disabled: '#B9B8B8',
    surface: '#F4F3F0',
    border: '#E5E3DC',
    success: '#269452',
  },
  font: {
    family:
      "Maison Neue, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    sizes: {
      xxsmall: '1rem',
      xsmall: '1.2rem',
      small: '1.4rem',
      medium: '1.6rem',
      large: '1.8rem',
      xlarge: '2rem',
      xxlarge: '2.4rem',
      huge: '3.2rem',
    },
  },
  spacings: {
    ...spacings,
    xxsmall: '0.8rem',
    xsmall: '1.6rem',
    small: '2rem',
    medium: '3.2rem',
    large: '4.0rem',
    xlarge: '4.8rem',
    xxlarge: '5.6rem',
    huge: '10.5rem',
  },
} as const;
